import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SideBarLink } from 'src/app/interfaces';
import { AuthService } from 'src/app/services/auth.service';
import { RouteTrackerService } from 'src/app/services/route-tracker.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  @Input() verified?: boolean;
  @Input() mustFinishPhone?: boolean;
  @Input() userFullyRegistered?: boolean;
  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter()

  storeId: string = '';
  links!: SideBarLink[];

  constructor(
    private auth: AuthService,
    private router: Router,
    private routeTrackerService: RouteTrackerService,
    private analytics: AnalyticsService) {
      this.routeTrackerService.getStoreId().subscribe((storeId: string) => {
        this.storeId = storeId
        this.setLinks();
      });
    }

  ngOnInit(): void {
    this.setLinks();
  }

  ngOnChanges(): void {
    if (this.userFullyRegistered === false) {
      this.setLinks();
    }
  }

  setLinks() {
    this.links = [
      { title: 'components.sidebar.scan', svgIcon: 'ph-regular-scan', route: '/pleasescan', action: () => this.navigate(`/pleasescan/${this.storeId}`) },
      { title: 'components.sidebar.profile', svgIcon: 'ph-regular-user', route: '/profile', action: () => this.navigate(`/profile/${this.storeId}`) },
      { title: 'components.sidebar.history', svgIcon: 'ph-regular-shopping-cart-simple', route: '/history', action: () => this.navigate(`/history/${this.storeId}`) },
      { title: 'components.sidebar.coupons', svgIcon: 'ph-regular-ticket', route: '/coupons', action: () => this.navigate(`/coupons/${this.storeId}`) },
      { title: 'components.sidebar.help', svgIcon: 'ph-regular-hand-heart', route: '/faq', action: () => this.navigate(`/faq/${this.storeId}`) },
    ]
    if (this.storeId) {
      this.links.unshift(
        { title: 'components.sidebar.store', svgIcon: 'reite-mini-store', route: '/catalog', action: () => this.navigate(`/catalog/${this.storeId}`) },
      )
    }
    else {
      this.links.unshift(
        { title: 'components.sidebar.home', svgIcon: 'ph-regular-house', route: '/home', action: () => this.navigate(`/home`) },
      )
    }
  }

  isActive(route: string): boolean {
    return this.router.isActive(route, { paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' });
  }

  logOut() {
    this.analytics.logEvent('logout');
    this.auth.logout(this.storeId).catch(() => console.log("Sidebar error."));
  }

  navigate(route: string) {
    let analyticsData: { [key: string]: string } = { 'route': route.split("/")[1]}; // '/profile/STOREID' -> 'profile'
    this.analytics.logEvent('navigate_to', analyticsData);
    this.toggleSideBarForMe.emit();
    this.router.navigateByUrl(route);
  }
}
